import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

import logo1 from "../assets/logo/clients/1.png";
import logo2 from "../assets/logo/clients/2.png";
import logo3 from "../assets/logo/clients/3.png";
import logo4 from "../assets/logo/clients/4.png";
import logo5 from "../assets/logo/clients/5.png";
import logo6 from "../assets/logo/clients/6.png";
import logo7 from "../assets/logo/clients/7.png";
import logo8 from "../assets/logo/clients/8.png";
import logo11 from "../assets/logo/clients/11.png";
import logo12 from "../assets/logo/clients/12.png";
import logo13 from "../assets/logo/clients/13.png";
import logo15 from "../assets/logo/clients/15.png";
import logo16 from "../assets/logo/clients/16.png";
import logo17 from "../assets/logo/clients/17.png";
import logo18 from "../assets/logo/clients/18.png";
import logo19 from "../assets/logo/clients/19.png";
import logo20 from "../assets/logo/clients/20.png";
import logo21 from "../assets/logo/clients/21.png";
import logo22 from "../assets/logo/clients/22.png";
import logo23 from "../assets/logo/clients/23.png";
import logo24 from "../assets/logo/clients/24.png";

const logos = [
  logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8,
  logo11, logo12, logo13, logo15, logo16, logo17, logo18, logo19, logo20,
  logo21, logo22, logo23, logo24,
];

function LogosSection() {
  return (
    <section className="w-full py-20 bg-black text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-12">
          Our Clients
        </h2>

        <Swiper
          modules={[Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          loop={true}
          speed={3000}
          grabCursor={true}
          allowTouchMove={true}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 3 },
            640: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
          }}
        >
          {logos.map((logo, index) => (
            <SwiperSlide key={index} className="flex justify-center">
              <div className="flex items-center justify-center">
                <img
                  src={logo}
                  alt={`logo-${index + 1}`}
                  className="
                    object-contain opacity-90
                    w-21 h-21
                    rounded-full
                    sm:w-22 sm:h-22
                    md:w-24 md:h-24
                    lg:w-28 lg:h-28
                    transition-transform duration-500
                    hover:scale-105
                  "
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default LogosSection;
